import * as actionTypes from './actionType';
import { I_GroupFilter, I_GroupFilterSelected } from './interface';

const GroupFilterStore = <I_GroupFilter>{
    PriceMax: 1,
    PriceMin: 0,
    TravelTypeList: [],
    DestinationList: [],
    DepartureList: [],
    AirlineList: [],
    TravelType: [],
    DepartureID: [],
    Days: [],
    AirlineID: [],
    Tags: [],
    BuList: [],
    IsEnsureGroup: null,
    LightboxDestination: [],
};

const GroupFilterSelected = <I_GroupFilterSelected>{
    // 用戶篩選的值
    // Keyword: '日本', // 先給預設keyword，這接口需要關鍵字才能發
    selectedPrices: [],
    selectedDestinationID: [],
    selectedDays: [],
    selectedTravelType: [],
    selectedDepartureID: [],
    selectedAirlineID: [],
    selectedTags: [],
    selectedIsEnsureGroup: null,
    selectedBuList: '',
    Page: 1,
    PageSize: 10,
    SortType: '',
};

const Group = {
    GroupFilterStore,
    GroupFilterSelected,
};

export const GroupReducer = (state = Group, action: any) => {
    switch (action.type) {
        case actionTypes.SET_GROUP_SUCCESS:
            return { ...state, GroupFilterStore: { ...state.GroupFilterStore, ...action.payload } };
        // return { ...state, [action.payload.filterTag]: action.payload };
        case actionTypes.SET_GROUP_SELECTED: // 傳入 { datafilter的key : 選到的值 }
            return {
                ...state,
                GroupFilterSelected: { ...state.GroupFilterSelected, ...action.payload },
            };
        case actionTypes.SET_GROUP_LIGHTBOXDEST: //光箱所有目的地
            return {
                ...state,
                GroupFilterStore: { ...state.GroupFilterStore, ...action.payload },
            };
        default:
            return state;
    }
};
